export default [
  {
    header: 'Important',
  },
  {
    title: 'Vocabular App',
    route: 'my_panel_vocabulary_app',
  },
  {
    title: 'Current Affairs',
    route: 'my_panel_current_affairs',
  },
  {
    title: 'Courses',
    route: 'my_panel_courses',
  },
  {
    title: 'Membership',
    route: 'my_panel_pricing',
  },
]
